import { Modal } from 'antd';
import { messages } from 'src/constants/messages';
/**
 *
 *
 * @param {string} apiUrl
 * @param {string} error
 * @param {func} apiCall
 * @param {string} [getName='']
 * @param {func} cbSuccess
 * @param {func} cbError
 * @returns
 */
function ModalDeleteConfirm(apiUrl, error, apiCall, getName = '', cbSuccess, cbError) {
  const config = {
    urlData: apiUrl,
    apiType: 'DELETE',
    value: null,
    method: 'DELETE'
  };
  Modal.confirm({
    title: messages.MODAL_DELETE_TITLE,
    content: messages.MODAL_DELETE_CONTENT,
    onOk(e) {
      e();
      return new Promise((resolve, reject) => {
        apiCall(config, getName, cbSuccess, cbError);
        if (!error) e();
        return error ? reject : resolve;
        // eslint-disable-next-line no-console
      }).catch(() => console.log('Có lỗi xảy ra!'));
    },
    okText: messages.MODAL_CONFIRM_OK,
    onCancel() { },
    cancelText: messages.MODAL_CONFIRM_CANCEL
  });
}

export default ModalDeleteConfirm;
